import { render, staticRenderFns } from "./CustomerInvoiceSplit.vue?vue&type=template&id=0fa25b00&scoped=true"
import script from "./CustomerInvoiceSplit.vue?vue&type=script&lang=js"
export * from "./CustomerInvoiceSplit.vue?vue&type=script&lang=js"
import style0 from "./CustomerInvoiceSplit.vue?vue&type=style&index=0&id=0fa25b00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa25b00",
  null
  
)

export default component.exports